import { render, staticRenderFns } from "./AssetsUploadPage.vue?vue&type=template&id=2ddfd989&scoped=true&"
import script from "./AssetsUploadPage.vue?vue&type=script&lang=ts&"
export * from "./AssetsUploadPage.vue?vue&type=script&lang=ts&"
import style0 from "./AssetsUploadPage.vue?vue&type=style&index=0&id=2ddfd989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddfd989",
  null
  
)

export default component.exports